import { useNavigate, useParams } from "react-router";
import { AnswerTable } from "./components/AnswerTable";
import { useCompany } from "../../context/CompanyContext";
import { useLocation } from "../../context/LocationContext";
import { useLazyQuery } from "@apollo/client";
import { GET_COMPANY, GET_LOCATION } from "../../features/graphql/query";
import { useEffect } from "react";
import { LoadingWrapper } from "ui";

interface ViewAnswerProps {
    onBack: () => void;
}

export const ViewAnswersPage = ({ onBack }: ViewAnswerProps) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const windowLocation = window.location.pathname.includes("/location") ? "location" : window.location.pathname.includes("company") ? "company" : "answers"
    const { setCompany, company } = useCompany();
    const { setLocation, location } = useLocation();
    const [fetchCompany, { loading: loadingCompany, data: dataCompany }] = useLazyQuery(GET_COMPANY);
    const [fetchLocation, { loading: loadingLocation, data: dataLocation }] = useLazyQuery(GET_LOCATION);
    useEffect(() => {
        if (windowLocation === "location" && location?.id != id) {
            fetchLocation({ variables: { id } })
        } else if (windowLocation === "company" && company?.id != id) {
            fetchCompany({ variables: { id } })
        }
    }, [windowLocation])

    useEffect(() => {
        if (dataCompany && windowLocation === "company") {
            setCompany(dataCompany?.company)
        } else if (dataLocation && windowLocation === "location") {
            setLocation(dataLocation?.location)
        }
    }, [dataCompany, dataLocation, windowLocation])
    return (
        <LoadingWrapper loading={!company && !location}>
            <AnswerTable onBack={onBack} />
        </LoadingWrapper>

    )
}